import React from 'react'
import { useFilter } from 'store'
import { navigate } from '@reach/router'

import { SelectInput } from 'components'
import styles from './SearchHeader.module.scss'

const SearchHeader = () => {
  const { setSelectedLocalities, setFieldAndScroll, $filter } = useFilter()

  const { localities, selectedLocalities } = $filter

  const setSelectedLocality = value => {
    setSelectedLocalities(value)

    if (!window.location.pathname.includes('/busca')) {
      navigate(`/busca/${value[0].slug}`)
    }
  }
  return (
    <div className={styles.searchHeader}>
      <span className={styles.inputContainer}>
        <SelectInput
          tabIndex="0"
          setSlug={newSlug => setFieldAndScroll('slug', newSlug)}
          setSelectedLocalities={setSelectedLocality}
          selectedLocalities={selectedLocalities}
          availableLocalities={localities}
          aria-autocomplete="list"
          autoComplete="no"
          aria-haspopup="true"
          role="combobox"
          className={styles.searchInput}
        />
      </span>
    </div>
  )
}

SearchHeader.propTypes = {}

SearchHeader.defaultProps = {}

export default SearchHeader
